var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: 'account.profile' }}},[_vm._v("Account")])}
var staticRenderFns = []

export { render, staticRenderFns }